const ef_scrollTopButton = document.querySelector(".ef-scrolltop");

if (typeof(ef_scrollTopButton) != "undefined" && ef_scrollTopButton != null) {

  // Show/hide scrolltop button after 1000px
  window.addEventListener("scroll", () => {

    let ef_scrollTop = document.documentElement.scrollTop;

    if (ef_scrollTop > 1000) {
      ef_scrollTopButton.classList.add("--is-visible");
    } else {
      ef_scrollTopButton.classList.remove("--is-visible");
    }
  });

  // Scroll to top of page on click
  ef_scrollTopButton.addEventListener("click", event => {

    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  });
}
